import { combineReducers } from '@reduxjs/toolkit';
import { advancedAnalyticsApi } from '../queries/advancedAnalytics';
import { customerActivitiesApi } from '../queries/customerActivities';
import { integrationsApi } from '../queries/integrations';
import { vendorApi } from '../queries/vendor';
import { vendorCustomerDetailsApi } from '../queries/vendorCustomerDetails';
import { internalDashboardApi } from '../internalDashboardApi';
import rulesReducer from '../slices/rulesSlice';
import batchesReducer from './batchesReducer';
import brandPagesReducer from './brandPagesReducer';
import cannabisBatchReducer from './cannabisBatchReducer';
import commonReducer from './commonReducer';
import dispensaryDashboardReducer from './dispensaryDashboardReducer';
import inventoryPricingReducer from './inventoryPricingReducer';
import invoiceSettingsReducer from './invoiceSettingsReducer';
import orderCreateReducer from './orderCreateReducer';
import productsReducer from './productsReducer';
import quickbooksReducer from './quickbooksReducer';
import storefrontReducer from './storefrontReducer';
import userReducer from './userReducer';
import vendorBrandsReducer from './vendorBrandsReducer';
import webhookDashboardReducer from './webhookDashboardReducer';

export const rootReducer = combineReducers({
  batches: batchesReducer,
  brandPages: brandPagesReducer,
  common: commonReducer,
  cannabisBatch: cannabisBatchReducer,
  dispensaryDashboard: dispensaryDashboardReducer,
  orderCreate: orderCreateReducer,
  products: productsReducer,
  quickbooks: quickbooksReducer,
  rules: rulesReducer,
  storefront: storefrontReducer,
  user: userReducer,
  vendorBrands: vendorBrandsReducer,
  webhookDashboard: webhookDashboardReducer,
  inventoryPricing: inventoryPricingReducer,
  invoiceSettings: invoiceSettingsReducer,
  [integrationsApi.reducerPath]: integrationsApi.reducer,
  [vendorApi.reducerPath]: vendorApi.reducer,
  [advancedAnalyticsApi.reducerPath]: advancedAnalyticsApi.reducer,
  [customerActivitiesApi.reducerPath]: customerActivitiesApi.reducer,
  [vendorCustomerDetailsApi.reducerPath]: vendorCustomerDetailsApi.reducer,
  [internalDashboardApi.reducerPath]: internalDashboardApi.reducer,
});
